// GA4 is loaded only after analytics consent on the production host.
// Never send query strings, private routes, personal data or free-text.
import { getConsent, onConsentChange } from "./consent";
const ID = process.env.REACT_APP_GA4_ID;
const PROD_HOSTS = ["american-farmstand.com", "www.american-farmstand.com"];
const EXCLUDED = [/^\/admin(?:\/|$)/, /^\/farm-setup/, /^\/(?:reset|forgot)-password/, /^\/orders(?:\/|$)/, /^\/farm-dashboard(?:\/|$)/, /^\/farm(?:er)?\/(?:onboarding|setup-review|stripe-complete)/];
let booted = false;
let scriptAdded = false;
let activeConsent = false;
let currentView = null;
const cleanPath = (path) => path.split(/[?#]/)[0];
const isExcluded = (path) => EXCLUDED.some((re) => re.test(cleanPath(path)));
const isProd = () => PROD_HOSTS.includes(window.location.hostname);
const granted = () => booted && getConsent() === "granted";
function gtag() { window.dataLayer.push(arguments); } // eslint-disable-line prefer-rest-params
function safeReferrer() {
  try { return document.referrer ? new URL(document.referrer).origin + "/" : ""; } catch { return ""; }
}
function pageFields(path) {
  return { page_location: window.location.origin + cleanPath(path), page_referrer: safeReferrer() };
}
function loadScript() {
  if (!granted() || !isProd() || scriptAdded || isExcluded(window.location.pathname)) return;
  scriptAdded = true;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${ID}`;
  document.head.appendChild(script);
}
function clearGaCookies() {
  const host = window.location.hostname;
  const domains = ["", host, `.${host}`, `.${host.replace(/^www\./, "")}`];
  document.cookie.split(";").map((c) => c.split("=")[0].trim())
    .filter((n) => n === "_ga" || n.startsWith("_ga_"))
    .forEach((n) => domains.forEach((d) => {
      document.cookie = `${n}=; Max-Age=0; path=/${d ? `; domain=${d}` : ""}`;
    }));
}
function applyConsent(value) {
  const wasGranted = activeConsent;
  activeConsent = value === "granted";
  window[`ga-disable-${ID}`] = !activeConsent;
  gtag("consent", "update", { analytics_storage: activeConsent ? "granted" : "denied" });
  if (!activeConsent) { clearGaCookies(); return; }
  if (!wasGranted && currentView && currentView.path === window.location.pathname) {
    gaPageView(currentView.path, currentView.title);
  }
}
export function initGA() {
  if (booted || !ID || typeof window === "undefined") return;
  booted = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = gtag;
  window[`ga-disable-${ID}`] = true;
  gtag("consent", "default", { analytics_storage: "denied", ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied" });
  gtag("js", new Date());
  gtag("config", ID, { send_page_view: false, ...pageFields("/"), allow_google_signals: false, allow_ad_personalization_signals: false });
  onConsentChange(applyConsent);
  if (getConsent()) applyConsent(getConsent());
}
export function gaPageView(path, title) {
  path = cleanPath(path);
  currentView = isExcluded(path) ? null : { path, title };
  if (!granted() || !currentView) return;
  loadScript();
  gtag("event", "page_view", { ...pageFields(path), page_path: path, page_title: title });
}
export function gaEvent(name, params = {}) {
  if (!granted() || isExcluded(window.location.pathname)) return false;
  loadScript();
  gtag("event", name, { ...params, ...pageFields(window.location.pathname) });
  return true;
}
export function gaEventThen(name, params, next) {
  if (!granted() || !isProd() || isExcluded(window.location.pathname)) { next(); return; }
  let done = false;
  const go = () => { if (!done) { done = true; next(); } };
  gaEvent(name, { ...params, transport_type: "beacon", event_callback: go });
  setTimeout(go, 600);
}
const lastView = new Map();
const once = (key) => { if (!granted() || Date.now() - (lastView.get(key) || 0) < 5000) return false; lastView.set(key, Date.now()); return true; };
export function gaViewItem(item) { if (once(`item:${item.item_category}:${item.item_id}`)) gaEvent("view_item", { items: [item] }); }
export function gaViewItemList(listId, listName, items) {
  if (items.length && once(`list:${listId}`)) gaEvent("view_item_list", { item_list_id: listId, item_list_name: listName, items });
}
